const clearPriceCheckerResult = (form: Element) => {
  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  if (form.dataset.priceCheckerForm !== "true") {
    return;
  }

  const container = form.closest<HTMLElement>("[data-price-checker-container]");
  const result = container?.querySelector<HTMLElement>(
    "[data-price-checker-result]"
  );

  if (result) {
    result.remove();
  }
};

export default clearPriceCheckerResult;
